import { ref } from "vue";

import profile from "../assets/images/sidebar-icons/profile.svg";
import friends from "../assets/images/sidebar-icons/friends.svg";
import products from "../assets/images/sidebar-icons/products.svg";
import orders from "../assets/images/sidebar-icons/orders.svg";
import reviews from "../assets/images/sidebar-icons/reviews.svg";
import favorites from "../assets/images/sidebar-icons/favorites.svg";
import messages from "../assets/images/sidebar-icons/messages.svg";
import basket from "../assets/images/sidebar-icons/basket.svg";
import support from "../assets/images/icons/support_icon.svg";
import subscriptions from "../assets/images/sidebar-icons/subscriptions.svg";
import b2b from "../assets/images/sidebar-icons/b2b.svg";

import { Sidebar } from "./types";

export const sidebarList = ref<Sidebar[]>([
  {
    icon: profile,
    title: "Профиль",
    link: "/profile/info",
  },
  {
    icon: b2b,
    title: "Маркетплейс",
    link: "/marketplace",
  },
  {
    icon: subscriptions,
    title: "Подписка",
    link: "/profile/subscription",
  },
  {
    icon: products,
    title: "Витрина",
    link: "/profile/products",
  },
  {
    icon: friends,
    title: "Друзья",
    link: "/profile/friends",
  },
  // {
  //   icon: orders,
  //   title: "Заказы",
  //   link: "/profile/orders",
  // },
  {
    icon: reviews,
    title: "Отзывы",
    link: "/profile/reviews",
  },
  {
    icon: favorites,
    title: "Избранное",
    link: "/profile/favorites",
  },
  {
    icon: messages,
    title: "Сообщения",
    link: "/profile/messages",
  },
  {
    icon: basket,
    title: "Корзина",
    link: "/profile/basket",
  },
  {
    icon: support,
    title: "Поддержка",
    link: "/profile/support",
  },
]);
